module.exports = __webpack_public_path__ + "img/star-gray.463d7392.svg";